<div>
  <app-collection-points-operated-filters *ngIf="years"
    [years]="years"
    (search)="searchData($event)">
  </app-collection-points-operated-filters>
  <mat-divider></mat-divider>
  <app-collection-points-operated-pie-chart *ngIf="data"
    [title]="text"
    [subtitle]="subtitle"
    [data]="data">
  </app-collection-points-operated-pie-chart>
</div>
